module.exports = __webpack_public_path__ + "static/img/on.56664417.svg";